import PropTypes from 'prop-types';
var hmButtonColors = ['primary', 'secondary', 'inherit', 'default', 'danger', 'success'];
var hmButtonColorPropType = PropTypes.oneOf(hmButtonColors);
export { hmButtonColors, hmButtonColorPropType };